export default "__VITE_ASSET__211ffad3__"